import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getCollectionDetails } from '../../hooks/Collectionhook';
import { contractAddress } from '../../config/BackendUrl';
import DynamicNFTCard from '../cards/DynamicCard';
import CardPlaceholder from '../cards/NFTCardPlaceholder';
import Pagination from '../Pagination';
import { listNFTs } from '../../hooks/NFTHook';

function CollcetionItemCard(props) {
  const [nfts, setNfts] = useState([]);
  const [hasMore, setHasMore] = useState(true); // Flag for infinite scroll
  const [currentPage, setCurrentPage] = useState(0);
  const [limit, setLimit] = useState(8);
  const [isPagination, setIsPagination] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const collectionAddress = props.contractAddress;
  const userIds = localStorage.getItem("userId");
  const location = useLocation();
  const userWalletAddress = localStorage.getItem("WalletAddress");


  useEffect(() => {
    fetchNFTs();
  }, [currentPage, props.filter]);

  console.log("filter", props, props.filter);

  const fetchNFTs = async () => {
    let Params;
    if (props.filter === null) {
      Params = { page: currentPage + 1, limit: 8, contractAddress: collectionAddress }
    }
    if (props.filter === "createdAt") {
      Params = { page: currentPage + 1, limit: 8, sortBy: "createdAt", contractAddress: collectionAddress }

    }
    if (props.filter !== null && props.filter !== "createdAt") {
      Params = { page: currentPage + 1, limit: 8, contractAddress: collectionAddress, category: props.filter }
    }
    else{
      Params = { page: currentPage + 1, limit: 8, sortBy: "createdAt", contractAddress: collectionAddress }
    }
    // const updatedNFTs = await loadAllNFTs(currentPage + 1, limit);
    const allNFTs = await listNFTs(Params); // Fetch all NFTs

    if (allNFTs.success) {
      // console.log("All NFTs", allNFTs);

      const NFT = allNFTs.data;
      // console.log("NFT Data", NFT);

      // function addIsLikeFlag (NFT, loginUserId) {
      const AddIsLikeFlag = NFT.map(item => {
        // console.log("NFT Items Data", item, item.likes);
        const isLike = item.likes.some(like =>
          // console.log("like",userIds, like.userId, loginUserId, like.userId === userIds))
          like.userId === userIds);
        // console.log("NFT isLike Data", isLike);

        return { ...item, isLike };
      });
      // }
      setNfts(AddIsLikeFlag);
      setPageCount(allNFTs.totalPages);
      setIsPagination(allNFTs.totalPages > 1);
      setHasMore(allNFTs.total > 0);
    }
  };

  useEffect(() => {
    if (location.state === true) {
      if (collectionAddress === contractAddress) {
        fetchNFTs();
      } else {
        getCollectionDetails(collectionAddress).then((data) => {
          if (data.status === 201) {
            fetchNFTs(data.data.ownerAddress);
          }
        });
      }
    }
  }, [location.state]);

  const handlePageChange = (selectedItem) => {
    setNfts([]);
    setCurrentPage(selectedItem.selected);
  };
  console.log("NFgdsvddf g", nfts, collectionAddress);

  return (
    <div>
      <div className="row">
        {nfts.length !== 0 ? (
          nfts.map((val, i) => (
            <div key={i} className="col-lg-3 col-md-4 col-sm-6">

              <DynamicNFTCard
                NFTLink={`/nftdetails/${val.contractAddress}/${val._id}`}
                contractAddress={val.contractAddress}
                currentOwnerPic={val?.currentOwner?.userId?.profilePicture}
                currentOwnerName={val?.currentOwner?.userId?.name}
                currentOwnerLink={val?.currentOwner?.walletAddress !== userWalletAddress ? `/otherProfile/${val?.currentOwner?.walletAddress}` : "/profile"}
                mediaUrl={val.imageUri} // Can be an image or video URL
                assetType={val.assetType} // Pass `true` for video or `false` for image
                title={val.title}
                price={val.price}
                likes={val.totalLikes}
                isLiked={val.isLike}
                tokenId={val.tokenId}
                isListed={val.listed}
                nftId={val._id}
                isCollection={false}
              />

            </div>
          ))
        ) : hasMore ? (
          [...Array(limit)].map((_, index) => (
            <div className="col-lg-3 col-md-4 col-sm-6" key={index}>
              <CardPlaceholder />
            </div>
          ))
        ) : (
          <h3>No NFT Available</h3>
        )}
      </div>
      {isPagination && (
        <Pagination
          pageCount={pageCount}
          onPageChange={handlePageChange}
          currentPage={currentPage}
        />
      )}
    </div>
  );
}

export default CollcetionItemCard;
